import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom'; 
import { fetchCategories } from '../api/categories';
import crows from '../assets/images/weblogo1.png';

import {RiUserSmileLine,RiArrowDownLine, RiApps2Line,RiDashboardFill, RiShoppingCart2Line,RiAccountCircleLine,RiHome6Line, RiLayoutGridLine, RiSearchLine, RiShoppingBag3Line, RiUser3Line } from 'react-icons/ri';

import '../styles/Navbar.css';
import { FaBold } from 'react-icons/fa';
import Top from './Top';


export default function Navbar() {
  const [user, setUser] = useState(null);
  const [cats, setCats] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  
  // User state sync logic
  useEffect(() => {
    const syncUser = () => {
      const stored = localStorage.getItem('user');
      if (stored) {
        try { setUser(JSON.parse(stored)); } catch { localStorage.removeItem('user'); setUser(null); }
      } else { setUser(null); }
    };
    syncUser();
    window.addEventListener('storage', syncUser);
    return () => window.removeEventListener('storage', syncUser);
  }, []);

  // Fetch categories logic
  useEffect(() => {
    fetchCategories()
      .then(res => setCats(res.data ))
      .catch(console.error);
  }, []);

  // Cart count logic
  useEffect(() => {
    async function loadCount() {
      if (user?.id) {
        try {
          const res = await fetch(`https://biosurgebackend-1.onrender.com/api/cart/${user.id}`);
          const items = await res.json();
          setCartCount(items.reduce((sum, i) => sum + (i.qty || 0), 0));
          return;
        } catch {
          // fallback to localStorage
        }
      }
      const stored = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartCount(stored.reduce((sum, i) => sum + (i.qty || 0), 0));
    }
    loadCount();
    window.addEventListener('storage', loadCount);
    return () => window.removeEventListener('storage', loadCount);
  }, [user]);


  return (
    <>
      {/* ================================== */}
      {/* ==      DESKTOP NAVIGATION      == */}
      {/* ================================== */}
  <Top/>
      <header className="desktop-nav">
        <div className="nav-container">
         
          <div className="nav-left">
           <img src={crows} alt="Crows Logo" className="nav-brand" /> 
          </div>

          <nav className="nav-center">
            <ul className="nav-links">
              <li><NavLink to="/">HOME</NavLink></li>
              <li className="dropdown">
                <NavLink to="/all-products">SHOP </NavLink>
                <ul className="dropdown-menu">
                   <li className='dan1'><Link to="/all-products">ALL CATEGORIES</Link></li>
                   {cats.map(cat => (
                     <li className="dan1" key={cat._id}>
                       <Link to={`/all-products?category=${cat._id}`} >{cat.name}</Link>
                     </li>
                   ))}
                </ul>
              </li>
               <li><NavLink to="/about-us" >ABOUT</NavLink></li>
               
              <li><NavLink to="/blog">BLOG</NavLink></li>          
               <li><NavLink to="/lookbook">LOOKBOOK</NavLink></li>
               <li><NavLink to="/contact">CONTACT</NavLink></li>
            </ul>
          </nav>

          <div className="nav-right">
            {/* <NavLink to="/all-products" className="nav-icon-btn" title="Search">
              <RiSearchLine />
            </NavLink> */}
            <NavLink to={user ? `/profile/${user.id}` : '/login'} className="nav-icon-btn" title="Profile">
              <RiUser3Line />
            </NavLink>
            <NavLink to="/cart" className="nav-icon-btn" title="Cart">
              <RiShoppingCart2Line /> 
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>} 
            </NavLink> 
          </div> 
        </div> 
      </header> 

      {/* ================================== */}
      {/* ==  MOBILE BOTTOM TAB NAVIGATION  == */}
      {/* ================================== */}

      <div className="mobile-top-header"> 
   <img src={crows} alt="Crows Logo" className="mobile-nav-brand" /> 
</div> 
      <nav className="mobile-bottom-nav"> 
        <NavLink to="/" className="nav-item"> 
          <RiDashboardFill className="nav-icon" /> 
          <span className="nav-text">Home</span> 
        </NavLink> 
        <NavLink to="/all-products" className="nav-item">
          <RiApps2Line className="nav-icon" />
          <span className="nav-text">Category</span>
        </NavLink>
        {/* <NavLink to="/all-products" className="nav-item">
          <RiSearchLine className="nav-icon" />
          <span className="nav-text">Search</span>
        </NavLink> */}
        <NavLink to="/cart" className="nav-item">
          <RiShoppingCart2Line className="nav-icon" />
          {cartCount > 0 && <span className="cart-badge mobile-badge">{cartCount}</span>}
          <span className="nav-text">Cart</span>
        </NavLink>
        <NavLink to={user ? `/profile/${user.id}` : '/login'} className="nav-item">
          <RiUser3Line className="nav-icon" />
          <span className="nav-text">Profile</span>
        </NavLink>
      </nav>
    </>
  );
}